import React, {Component as ReactComponent} from 'react'

export default (OriginalComponent) => class DecoratedComponent extends ReactComponent {
    constructor(props) {
        super(props)
        const {initOpen} = props
        this.state = {
            isOpen : initOpen
        }
    }

    componentWillReceiveProps(nextProps) {
        let {forceOpen : nextForceOpen} = nextProps
        let {forceOpen : thisForceOpen} = this.props
        if (nextForceOpen !== thisForceOpen) {
            this.setState({
                isOpen : nextForceOpen
            })
        }
    }

    toggleOpen = () => this.setState({
        isOpen : !this.state.isOpen
    })

    render() {
        return <OriginalComponent {...this.props} isOpen={this.state.isOpen} toggleOpen={this.toggleOpen} />
    }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/decorators/toggleOpen.js